<template>
  <v-dialog :value="open" max-width="560" persistent>
    <v-card class="rounded-lg">
      <v-toolbar color="error" dark flat>
        <v-toolbar-title>
          <v-icon left>mdi-calendar-remove</v-icon>
          Xóa đơn hàng theo ngày
        </v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn icon :disabled="loading" @click="close"><v-icon>mdi-close</v-icon></v-btn>
      </v-toolbar>

      <v-card-text class="pa-5">
        <v-alert type="warning" text dense class="mb-5">
          Tất cả đơn bán trong khoảng ngày đã chọn sẽ bị xóa khỏi danh sách và số lượng tồn kho liên quan sẽ được cập nhật lại. Thao tác này không thể hoàn tác trên màn hình.
        </v-alert>

        <v-form ref="form">
          <v-row>
            <v-col cols="12" sm="6">
              <v-text-field
                v-model="dateFrom"
                type="date"
                label="Từ ngày"
                outlined
                prepend-icon="mdi-calendar-start"
                :max="dateTo || undefined"
                :rules="[v => !!v || 'Vui lòng chọn ngày bắt đầu']"
              />
            </v-col>
            <v-col cols="12" sm="6">
              <v-text-field
                v-model="dateTo"
                type="date"
                label="Đến ngày"
                outlined
                prepend-icon="mdi-calendar-end"
                :min="dateFrom || undefined"
                :rules="[v => !!v || 'Vui lòng chọn ngày kết thúc']"
              />
            </v-col>
          </v-row>
        </v-form>

        <v-checkbox
          v-model="confirmed"
          color="error"
          hide-details
          label="Tôi hiểu và xác nhận xóa các đơn hàng trong khoảng ngày này"
        />
      </v-card-text>

      <v-divider />
      <v-card-actions class="pa-4">
        <v-spacer />
        <v-btn text :disabled="loading" @click="close">Hủy</v-btn>
        <v-btn color="error" dark :loading="loading" :disabled="!confirmed" @click="submit">
          <v-icon left>mdi-delete</v-icon>
          Xóa đơn hàng
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import orderModule from '@/api/order'

const orderActions = orderModule.actions

export default {
  props: {
    open: { type: Boolean, default: false },
    initialDateFrom: { type: String, default: '' },
    initialDateTo: { type: String, default: '' }
  },
  data() {
    const today = new Date().toISOString().slice(0, 10)
    return {
      loading: false,
      confirmed: false,
      dateFrom: this.initialDateFrom || today,
      dateTo: this.initialDateTo || today
    }
  },
  watch: {
    open(value) {
      if (!value) return
      this.dateFrom = this.initialDateFrom || this.dateFrom
      this.dateTo = this.initialDateTo || this.dateTo
      this.confirmed = false
    }
  },
  methods: {
    close() {
      if (!this.loading) this.$emit('toggle')
    },
    async submit() {
      if (!this.$refs.form.validate()) return
      if (this.dateTo < this.dateFrom) {
        this.$snackbar.error('Ngày kết thúc phải từ ngày bắt đầu trở đi.')
        return
      }

      this.loading = true
      try {
        const response = await orderActions.deleteByDateRange({
          date_from: this.dateFrom,
          date_to: this.dateTo
        })
        const count = response.data?.data?.deleted_count || 0
        this.$snackbar.success(`Đã xóa ${count} đơn hàng.`)
        this.$emit('deleted')
        this.$emit('toggle')
      } catch (error) {
        this.$snackbar.error(error.response?.data?.message || 'Không thể xóa đơn hàng. Vui lòng thử lại.')
      } finally {
        this.loading = false
      }
    }
  }
}
</script>
